import {connect} from "react-redux";
import Reviews from "./Reviews";
import {compose} from "redux";
import {WithAppendHeaderAndFooterHOC} from "../../HOC/WithAppendHeaderAndFooterHOC";
import {WithAppendSidebarHOC} from "../../HOC/WithAppendSidebarHOC";
import {
    getNavReviewParams,
    getReviewList,
    setReviewListFromCache,
    setReviewNavParamsFromCache,
} from "./actions";
import {WithModeratorSearchHOC} from "../../HOC/WithModeratorSearchHOC";
import {searchObjects} from "../Objects/actions";


let mapStateToProps = (state) => {
    return {
        reviews: state.reviewsPage.reviews,
        statusList: state.reviewsPage.statusList,
        navParams: state.reviewsPage.navParams,
        filter: state.reviewsPage.filter,

    }
};


export default compose(connect(mapStateToProps, {
    getReviewList,
    getNavReviewParams,
    setReviewListFromCache,
    setReviewNavParamsFromCache,
    searchObjects
}), WithAppendHeaderAndFooterHOC, WithAppendSidebarHOC, WithModeratorSearchHOC)(Reviews);



